import React from 'react';
import * as S from './Testimonial.styles';

import IconSelector from '@ibibo/icon-selector';
import useCarousel from '@ibibo/use-carousel';
import {defaultTheme} from '@ibibo/build-theme';

const data = [
  {
    id: 'item1',
    icon: 'property',
    agentPic: 'https://assets-gos3.goibibo.com/pavanputra_tours-1601365411.jpg',
    title: 'Hardev Dangar',
    agencyName: 'Pavanputra Tours and Travels',
    subTitle:
      'myPartner is a great platform for us travels agents. We get the best rates for most of the hotels here. The cancellation policies are amazing, and the feature of White Label has given us a lot of security. The UI is easy on the eyes and very easy to use. The new WhatsApp feature is a blessing for us, as this industry demands a lot of hard work and this feature will surely help curb down the efforts put in by us',
  },
  {
    id: 'item2',
    icon: 'deal',
    agentPic: 'https://assets-gos3.goibibo.com/pinnova_travels-1601365477.jpg',
    title: 'Mehul Jain',
    agencyName: 'Pinnova Travels',
    subTitle:
      'Its interface is easy to use for any travel agent. Express Care feature, in which corrections can be done online without having to call the customer care, is quite good. The new WhatsApp share option adds to the beauty of this portal. It is quite easy to upload the balance in the portal and the rate comparison feature is also good',
  },
  {
    id: 'item3',
    icon: 'onboardingmysafety',
    agentPic: 'https://assets-gos3.goibibo.com/raj_travels-1601365337.jpg',
    title: 'Akshay Thakur',
    agencyName: 'Raj Travel and Tours',
    subTitle:
      'I can find hotels for check-in after 6 months as well for check-in today, all with full cancellation options. I haven’t seen this anywhere else. Also the range of properties myPartner provides is unbelievable.',
  },
  {
    id: 'item4',
    icon: 'assure',
    agentPic: 'https://assets-gos3.goibibo.com/sahu_tours-1601365372.jpg',
    title: 'Devendra Sahu',
    agencyName: 'Sahu Tours and Travels',
    subTitle:
      'In my experience, I really liked the service and support provided on this portal. I have made a comparison of prices and found really good prices here. The White Label and WhatsApp features are very helpful for the business and our customer services.',
  },
  {
    id: 'item5',
    icon: 'assure',
    agentPic: 'https://assets-gos3.goibibo.com/rajshree_consultancy-1601365444.jpg',
    title: 'Kaplesh Kumar Ram',
    agencyName: 'Rajshree Consultancy',
    subTitle:
      'The platform is easy to use and myPartner provides excellent support for its customers. The prices are very cheap, even better than the direct-hotel-prices. I will use it for a long time. Good association.',
  },
  {
    id: 'item6',
    icon: 'assure',
    agentPic: 'https://assets-gos3.goibibo.com/travels_com-1601365549.jpg',
    title: 'Sunil Chaudhary',
    agencyName: 'Travels.com',
    subTitle:
      'My experience was very good with myPartner. The features are very helpful for business and customer service. I generally check prices with other platforms and have found myPartner to have a lower price every time, and a better selection of hotels too. Looking forward to a meaningful collaboration.',
  },
  {
    id: 'item7',
    icon: 'assure',
    agentPic: 'https://assets-gos3.goibibo.com/sv_travels-1601365518.jpg',
    title: 'Sudharsan Mandya',
    agencyName: 'SV Travels',
    subTitle:
      'I have found myPartner highly user friendly. It’s very easy to search and book hotels for my clients. Also, the booking details can be shared easily through WhatsApp. I have received a very good response through this platform.',
  },
  // {
  //     id: 'item8',
  //     icon: 'assure',
  //     agentPic: '',
  //     title: '',
  //     agencyName: 'Azure The Travel Shoppe',
  //     subTitle: 'Such a wonderful experience to associate with myPartner. I have to say that there are a lot of hotel choices on this portal. In my experience, myPartner has perfect service with good discounted rates. Looking forward to a healthy relationship in future.'
  // }
];

const styleProps = {
  width: '2rem',
  height: '2rem',
  fill: defaultTheme.colors.blue.base,
};

const TestimonialBlock = () => {
  const deviceWidth = typeof window === 'undefined' ? 100 : window.screen.width;

  let cardNo;
  if (deviceWidth > 1024) {
    cardNo = 3;
  } else {
    cardNo = 7;
  }

  const {dataList, increment, decrement, isLeftCursorActive, isRightCursorActive} = useCarousel(
    data,
    cardNo,
  );

  return (
    <S.InfoStripWrapper>
      <S.HeaderTextWrap>
        <S.TestimonyHeadText>15,000+ Agents Love myPartner</S.TestimonyHeadText>
        <S.TestimonySubText>Testimonials</S.TestimonySubText>
      </S.HeaderTextWrap>
      <S.InfoBlockInner>
        <S.MoreInfoList>
          {(isLeftCursorActive && (
            <S.ArrowIconLeftWrapper onClick={decrement}>
              <IconSelector iconKey="leftarrow" props={styleProps} />
            </S.ArrowIconLeftWrapper>
          )) ||
            null}
          {dataList.map(item => (
            <li key={item.id}>
              <S.MainContentWrap>
                <S.ContentOuterWrap>
                  <S.ContentInfoWrap>
                    <S.UserImgWrap>
                      <img src={item.agentPic} />
                    </S.UserImgWrap>
                  </S.ContentInfoWrap>
                  <S.ContentMainTextWrap>
                    <S.ContentMainText>{item.subTitle}</S.ContentMainText>
                  </S.ContentMainTextWrap>
                  <S.UserInfoWrap>
                    <S.UserNameText>{item.title}</S.UserNameText>
                    <S.UserAgencyNameText>{item.agencyName}</S.UserAgencyNameText>
                  </S.UserInfoWrap>
                </S.ContentOuterWrap>
              </S.MainContentWrap>
            </li>
          ))}
          {(isRightCursorActive && (
            <S.ArrowIconRightWrapper onClick={increment}>
              <IconSelector iconKey="rightarrow" props={styleProps} />
            </S.ArrowIconRightWrapper>
          )) ||
            null}
        </S.MoreInfoList>
      </S.InfoBlockInner>
    </S.InfoStripWrapper>
  );
};

export default TestimonialBlock;
